const theme = {
    body: {
        background: "#080808",
        text: "#999",
        headers: "#FFF"
    },
    colors: {
        black: "#000",
        white: "#FFF",
        gray: "#161616",
    },
    queries: {
        mobile: "725px",
        tablet: "900px",
        desktop: "1150px",
    },
    transition: "all cubic-bezier(0.1, 0.1, 0.1, 0.1) 0.1s",
    typography: {
        font: "system-ui",
        fontSize: "18px",
        fontWeight: "400",
        fontLineHeight: "1.6",
        fontLetterSpacing: "1px",
        headerWeight: "600"
    }
};

export default theme;
